import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { ApiService } from '../../common/services/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class CreateRecipeService {

  constructor(
      private apiService: ApiService) { }

    getData(url): Observable<any> {
      return this.apiService.get(url).pipe(timeout(300000));
    }
    postData(url, body): Observable<any> {
      return this.apiService.post(url, body).pipe(timeout(300000));
    }


  }
